export default __webpack_public_path__ + "static/media/search-zoom.551730b5.svg";